import { render, staticRenderFns } from "./MBS.vue?vue&type=template&id=528cc428&scoped=true&"
import script from "./MBS.vue?vue&type=script&lang=js&"
export * from "./MBS.vue?vue&type=script&lang=js&"
import style0 from "./MBS.vue?vue&type=style&index=0&id=528cc428&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528cc428",
  null
  
)

export default component.exports